export const API_VERSION = 'v1';
export const API_BASE_PATH = `/api/${API_VERSION}`;
export const AUTH_SESSION_PATH = `${API_BASE_PATH}/auth/session`;
export const AUTH_REFRESH_PATH = `${API_BASE_PATH}/auth/refresh`;
